module.exports = __webpack_public_path__ + "static/img/client2_big.1355e2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientDetail/client2_big.jpg
// module id = r3yJ
// module chunks = 1